import {HttpParams} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {BaseFieldType} from 'compob2b-libs';

@Component({
    selector: 'app-auto-complete',
    templateUrl: './auto-complete.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AutoCompleteComponent extends BaseFieldType implements OnInit {
  selectedOption: { id: number; header: string } = null;
  items$: Observable<{ id: number; header: string }[]>;
  searchInput$ = new Subject<string>();

  ngOnInit(): void {
    this.items$ = this.searchInput$
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        takeUntil(this.unsubscribe),
        tap(_ => this.loading = true),
        switchMap(term => {
          const params = new HttpParams().set(this.field.props.searchProp, term);
          return this.compoApiService.getWithParams<any[]>(`${this.field.props.searchURI}/autocomplete-search/50`, params)
            .pipe(map(response => {
              if (!term) {
                return this.compoApiService.naturalSort(response.data, 'header');
              }
              else {
                return response.data;
              }
            }))
        }),
        tap(_ => this.loading = false),
      );

    this.formControl.valueChanges
      .pipe(take(1))
      .subscribe(initialValue => this.setInitialValue(initialValue));
  }

  setInitialValue(initialValue: number): void {
    this.formControl.setValue(initialValue);
    if (!initialValue || this.field.props.searchURI == '/countries') {
      return;
    }

    this.compoApiService.get(`${this.field.props.searchURI}/${initialValue}/header`)
      .pipe(
        map(response => response.data),
        take(1),
      )
      // @ts-ignore
      .subscribe((header: string) => {
        this.selectedOption = {id: initialValue, header};
        this.cdr.detectChanges();
      });
  }

  changeSelectedOption(option: { id: number, header: string }) {
    if (option.header) {
      this.selectedOption = option;
    }

    this.formControl.setValue(option.id);
  }

  compareItems(a: { id: number }, b: { id: number }): boolean {
    return a.id === b.id;
  }

  onClear(): void {
    this.formControl.setValue(null);
  }
}
